import React from "react";
import {
  AnalystHeroShell,
  AnalystSkeletonHero,
  AnalystSplitGrid,
} from "./Analyst.styles";

const AnalystProfileSkeleton = () => (
  <>
    <AnalystHeroShell aria-hidden="true">
      <AnalystSkeletonHero />
    </AnalystHeroShell>
    <AnalystSplitGrid aria-hidden="true" style={{ marginTop: 48 }}>
      <AnalystSkeletonHero style={{ height: 240 }} />
      <AnalystSkeletonHero style={{ height: 240 }} />
    </AnalystSplitGrid>
  </>
);

export default AnalystProfileSkeleton;
